import SharedSortableLists from "./SharedSortableLists";
import AreaDirectorDigitalJobsIndex from "./AreaDirectorDigitalJobsIndex";

class AreaDirectorSortableDigitalJobsList extends SharedSortableLists {
  constructor(props) {
    super(props);
    this.dateColumnTitle = props.dateColumnTitle;
  }

  reactTableComponent() {
    return AreaDirectorDigitalJobsIndex;
  }

  reactTableExtra() {
    return {
      dateColumnTitle: this.dateColumnTitle
    }
  }

  defaultSortKey() {
    return "name";
  }

  sortData() {
    switch (this.sortKey) {
      case "name":
        return this.sortBy({ attr: "client_name" });
      case "job_type":
        return this.sortBy({ attr: "social_ad_type" });
      case "status":
        return this.sortBy({ attr: "color_status_in_words", reverse: true });
      case "date":
        return this.sortBy({ attr: "display_date" });
      default:
        return this.data;
    }
  }
}

export default AreaDirectorSortableDigitalJobsList;
